import styled from 'styled-components';
import React from 'react'
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import AdvanceFilter from './AdvanceFilter';
import Text from '../../genericComponents/Text';
import {useTranslation} from 'react-i18next'; 
import { THEME } from '../../genericComponents/globalStyles';

export default function AdvanceFilterModal({isVisible,setVisible,...rest}){
  const { t } = useTranslation();
  return (
    <ModalContentTotal
      visible={isVisible} 
      width={400}
      footer={null}
      closeIcon={<CloseOutlined style={{color:'#FFF'}}/>}
      onCancel={()=>setVisible(false)}
    >
        <Header>
          <div/>
          <Text titleSize={2} titleLevel={1}>{t('advanced_filters')}</Text>
          <CloseButton>
            <CloseOutlined style={{color:THEME.colors.blue}}/>
          </CloseButton>
        </Header>
        <Container>
          <AdvanceFilter {...rest}/>
        </Container>
    </ModalContentTotal>
  )
}

const ModalContentTotal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
    overflow:hidden;
  }
  .ant-modal-content {
    border-radius: 12px;
  }
`;
const Container = styled.div`
  background-color: #EEEEEE;
  padding: 0 20px;
`;
const Header = styled.div`
  padding: 20px 20px;
  text-align: center;
  display: flex;
  justify-content: space-between;

`;
const CloseButton = styled.button`
  border: none;
  background: none;

`;